import styled from 'styled-components/macro'

const Paragraph = styled.p`
  font-size: 20px;
  line-height: 32px;
  color: rgba(0, 0, 0, 0.45);
`

export default Paragraph
